<div class="wrp">
    <div class="wrp1">
        <div>
            <mat-icon class="bigicon" fontIcon="insights"></mat-icon>
        </div>
        <div class="cc1">
            <span>Preise für Ihre</span>
            <span>Suche beobachten <mat-icon class="smlicon" matTooltipClass="matTooltip"
                    #prsalarmr="matTooltip" (click)="prsalarmr.toggle();$event.stopPropagation();"
                    matTooltip="Wir senden Ihnen eine E-Mail, wenn sich der Preis für dieses Hotel ändert."
                    fontIcon="info"></mat-icon></span>
        </div>
    </div>
    <div class="cc2" (click)="checkPra($event);">
        <div class="cc4">
            <mat-icon fontIcon="alarm"></mat-icon>
            <span class="noselect ml5"> Preisalarm</span>
        </div>
        <div (click)="$event.stopPropagation();">
            <mat-slide-toggle [(ngModel)]="preisAlarm" (change)="checkPratogel();" color="primary"></mat-slide-toggle>
        </div>
    </div>
    <div class="cc3">
        <a class="cclink noselect" (click)="gotoPreisAlarm()">Meine Preisalarme verwalten</a>
    </div>
</div>